"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var categoriesList_1 = require("common/global/categoriesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var warehousesList_1 = require("common/global/warehousesList");
var exportWarehouseItemsTableToExcel_1 = require("portal/components/Grid/helpers/exportWarehouseItemsTableToExcel");
var hasWarehousePermission_1 = require("portal/pages/Projects/hasWarehousePermission");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ChangeStorageLocationDialog_1 = __importDefault(require("../Dialogs/ChangeStorageLocationDialog"));
function WarehouseAssetsTable(props) {
    var _this = this;
    var _a = (0, react_1.useState)(false), showChangeStorageDialog = _a[0], setShowChangeStorageDialog = _a[1];
    var _b = (0, react_1.useState)(), warehouseItem = _b[0], setWarehouseItem = _b[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var warehouseItems = (0, react_1.useMemo)(function () { return props.warehouseItems.filter(function (item) { return item.type == "asset"; }); }, [props.warehouseItems]);
    var columnsOfItems = (0, react_1.useMemo)(function () { return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            name: "NO",
            title: t("warehouse.NO"),
            getCellValue: function (r) { return parseFloat(r.index + 1); },
        },
        {
            name: "storePoint",
            title: "Store Point",
            getCellValue: function (r) { var _a; return (_a = r.storePoint) !== null && _a !== void 0 ? _a : "Not Specified"; },
        }
    ], (props.warehouseId
        ? []
        : [
            {
                name: "warehouseId",
                title: t("common.warehouse"),
                getCellValue: function (r) { var _a; return (_a = warehousesList_1.globalWarehousesData[r.warehouseId]) === null || _a === void 0 ? void 0 : _a.name; },
            },
        ]), true), (props.projectId
        ? []
        : [
            {
                name: "projectId",
                title: t("projects.projectCode"),
                getCellValue: function (r) { var _a; return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.code; },
            },
        ]), true), (props.budgetLineId
        ? []
        : [
            {
                name: "budgetLineId",
                title: t("budget.budgetLine"),
                getCellValue: function (r) { var _a; return (_a = budgetLinesList_1.globalBudgetLinesData[r.budgetLineId]) === null || _a === void 0 ? void 0 : _a.code; },
            },
        ]), true), (props.productId
        ? []
        : [
            {
                name: "cachedProductName",
                title: t("products.productName"),
            },
            {
                name: "cachedProductUnit",
                title: t("common.unit"),
                getCellValue: function (r) { var _a; return (_a = unitsList_1.globalUnitsData[r.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name; },
            },
            {
                name: "cachedProductDescription",
                title: t("products.description"),
            },
            {
                name: "cachedProductCategory",
                title: t("common.category"),
                getCellValue: function (r) { var _a; return (_a = categoriesList_1.globalCategoriesData[r.cachedProductCategory]) === null || _a === void 0 ? void 0 : _a.name; },
            },
        ]), true), (props.stockNumber
        ? []
        : [
            {
                name: "stockNumber",
                title: t("warehouse.stockNumber"),
            },
        ]), true), (props.batchNumber
        ? []
        : [
            {
                name: "batchNumber",
                title: t("warehouse.batchNumber"),
            },
        ]), true), [
        {
            name: "serialNumbers",
            title: t("warehouse.serialNumbers"),
            getCellValue: function (r) {
                var _a;
                return typeof r.serialNumbers == "string"
                    ? r.serialNumbers
                    : (_a = r.serialNumbers) === null || _a === void 0 ? void 0 : _a.join(", ");
            },
        },
        {
            name: "assetsNumbers",
            title: t("warehouse.assetsNumbers"),
            getCellValue: function (r) {
                var _a;
                return typeof r.assetsNumbers == "string"
                    ? r.assetsNumbers
                    : (_a = r.assetsNumbers) === null || _a === void 0 ? void 0 : _a.join(", ");
            },
        },
        {
            name: "storageLocation",
            title: t("warehouse.storageLocation"),
        },
        {
            name: "specification",
            title: t("warehouse.specification"),
        },
        {
            name: "from",
            title: t("common.from"),
        },
        {
            name: "dnNumber",
            title: "From DN",
        },
        {
            name: "quantity",
            title: t("common.quantity"),
        },
        {
            name: "unitPrice",
            title: t("common.unitPrice"),
            getCellValue: function (row) { var _a; return (_a = row.unitPrice) !== null && _a !== void 0 ? _a : 0; },
        },
        {
            name: "totalPrice",
            title: t("common.totalPrice"),
            getCellValue: function (row) { var _a; return row.quantity * ((_a = row.unitPrice) !== null && _a !== void 0 ? _a : 0); },
        },
        {
            name: "actions",
            title: t("warehouse.changeStorageLocation"),
            getCellValue: function (row) {
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: function () {
                            setWarehouseItem(row);
                            setShowChangeStorageDialog(true);
                        } }, { children: t("warehouse.edit") })) }));
            },
        },
    ], false); }, [
        props.batchNumber,
        props.budgetLineId,
        props.productId,
        props.projectId,
        props.stockNumber,
        props.warehouseId,
        t,
    ]);
    var items = warehouseItems.filter(function (e) { return e.quantity > 0; });
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: items, columns: columnsOfItems, getRowId: function (r) { return r.id; } }, { children: __spreadArray(__spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({ pagination: true, pageSize: 50 }), true), [(0, hasWarehousePermission_1.hasWarehousePermission)(props.warehouseId, ["exportWarehouseItems"]) ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                            position: "absolute",
                            left: "65%",
                            marginTop: 16,
                            zIndex: 999,
                        }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var fileName, fields, titles;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        fileName = "Warehouse Items Table";
                                        fields = [
                                            "storePoint",
                                            "id",
                                            "productId",
                                            "warehouseId",
                                            "projectId",
                                            "budgetLineId",
                                            "cachedProductName",
                                            "cachedProductDescription",
                                            "cachedProductUnitName",
                                            "cachedProductCategory",
                                            "quantity",
                                            "serialNumbers",
                                            "assetsNumbers",
                                            "stockNumber",
                                            "batchNumber",
                                            "storageLocation",
                                            "expiryDate",
                                            "from",
                                        ];
                                        titles = [
                                            "Store Point",
                                            "id",
                                            "productId",
                                            "Warehouse",
                                            "Project",
                                            "Budget Line",
                                            "Product Name",
                                            "Product Description",
                                            "Product Unit",
                                            "Product categoty",
                                            "Product Quantity",
                                            "Serial Numbers",
                                            "Assets Numbers",
                                            "Stock Number",
                                            "Batch Number",
                                            "Storage Location",
                                            "Expiry Date",
                                            "From",
                                        ];
                                        return [4 /*yield*/, (0, exportWarehouseItemsTableToExcel_1.exportWarehouseItemsTableToExcel)(items, fields, titles, fileName)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, { children: t("common.exportToExcel") }))) : null], false) })), showChangeStorageDialog ? ((0, jsx_runtime_1.jsx)(ChangeStorageLocationDialog_1.default, { modalState: showChangeStorageDialog, setModalState: setShowChangeStorageDialog, warehouseItem: warehouseItem })) : null] }));
}
exports.default = WarehouseAssetsTable;
